module.exports = __webpack_public_path__ + "static/media/numberous-jars-1-new.b03072c1.png";